module.exports = __webpack_public_path__ + "static/media/slide3.4a114b79.jpg";